import styled from "styled-components";

const PeopleLeadSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 10px;
  margin: 2px;
  .button_class {
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
`;

export default PeopleLeadSc;
